<template>
	<div class="flex">
		<vx-tooltip text="Bestel datum" class="pr-5">
			{{ order.order.order_placed_date_time }}
		</vx-tooltip>

		<vx-tooltip text="Uiterste leverdatum" v-if="order.order.type === 1 && order.order.latest_delivery_date !== null">
			{{ order.order.latest_delivery_date }}
		</vx-tooltip>
		<vx-tooltip text="Exacte leverdatum" v-if="order.order.type === 1 && order.order.latest_delivery_date === null && order.order.exact_delivery_date !== null">
			{{ order.order.exact_delivery_date }}
		</vx-tooltip>
		<vx-tooltip text="Leverdatum" v-if="order.order.type === 1 && order.order.latest_delivery_date === null && order.order.exact_delivery_date === null">
			Onbekend
		</vx-tooltip>

		<vx-tooltip text="Verzenddatum, op deze datum verzend je de bestelling" v-if="order.order.type === 2 && order.order.shipping_date !== null">
			{{ order.order.shipping_date }}
		</vx-tooltip>
		<vx-tooltip text="Leverdatum, op deze datum verwacht de klant de bestelling" v-if="order.order.type === 2 && order.order.delivery_date !== null">
			{{ order.order.delivery_date }}
		</vx-tooltip>
		<vx-tooltip text="Leverdatum, op deze datum verwacht de klant de bestelling"
					v-if="order.order.type === 2 && order.order.shipping_date === null && order.order.delivery_date === null">
			Zo snel mogelijk
		</vx-tooltip>
	</div>
</template>

<script>

export default {
	props: {
		order: {
			type: Object,
			required: true
		},
	},
}
</script>
